// "This week" gate (docs/HOME-2026-10.md, F6). The only home card code in the main bundle: it
// decides whether to load the card, then waits for load + idle with the start screen showing
// and imports the lazy chunk (its own JS + CSS, never precached). Nothing is requested before
// load, and nothing at all when the card is off, onboarding is live or this is a /?play= link.

// Pure: may the card load on this visit? get = the settings getter.
export function homeAllowed(ok, get) { return !!ok && get("homeTouches") !== false && get("homeWeek") !== false; }

// ok: onboarding is not live and this is not a /?play= link. ctx: what the chunk needs (see main.js).
export function initHome(ok, ctx) {
	const root = document.documentElement;
	if (!homeAllowed(ok, ctx.get)) { delete root.dataset.home; return; } // free the reserved room
	let started = false;
	const go = () => {
		if (started || !ctx.isStartVisible()) return;
		started = true;
		mo.disconnect();
		const css = document.createElement("link");
		css.rel = "stylesheet"; css.href = __RVM.homeCss;
		document.head.appendChild(css);
		import(__RVM.homeJs).then((m) => m.start(ctx)).catch(() => { delete root.dataset.home; });
	};
	// The start screen may come back later (a new tab); load then.
	const mo = new MutationObserver(() => { if (ready) go(); });
	let ready = false;
	const onLoad = () => {
		const idle = () => { ready = true; mo.observe(ctx.startEl, { attributes: true, attributeFilter: ["hidden"] }); go(); };
		if (window.requestIdleCallback) requestIdleCallback(idle, { timeout: 4000 }); else setTimeout(idle, 200);
	};
	if (document.readyState === "complete") onLoad(); else addEventListener("load", onLoad, { once: true });
}
